import { Component, Input } from '@angular/core';
import { ApplicationStatusEnum } from '../../common/general-types/briefs.dto';

@Component({
  selector: 'atom-application-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './application-status-badge.component.html',
  styleUrl: './application-status-badge.component.css'
})
export class ApplicationStatusBadgeComponent {

  @Input('applicationStatus') applicationStatus: ApplicationStatusEnum | undefined
  @Input('inputClass') inputClass: string = "inline-flex items-center gap-x-1.5 rounded-full px-2 py-0.5 text-md font-medium ring-1 ring-inset"

  getInviteStatus(status: number) {
    switch (status) {
      case 1:
        return 'Invited';
      case 2:
        return 'Applied';
      case 3:
        return 'Hired';
      case 4:
        return 'Post';
      case 5:
        return 'Posted';
      case 6:
        return 'Completed';
      case 7:
        return 'Completed';
      case 8:
        return 'Started';
      case 9:
        return 'Invite Declined';
      case 10:
        return 'Declined';
      case 11:
        return 'Invite Removed';
      case 12:
        return 'Bonus Paid';
      case 13:
        return 'Un-hired';
      case 14:
        return 'Approved';
      default:
        return 'Invite';
    }
  }

  getStatusColour(status: number) {
    let baseClass = this.inputClass
    switch (status) {
      case 1:
        baseClass += ' pill pill-teal';
        break;
      case 2:
        baseClass += ' pill pill-blue';
        break;
      case 3:
        baseClass += ' pill pill-indigo';
        break;
      case 4:
        baseClass += ' pill pill-orange';
        break;
      case 5:
        baseClass += ' pill pill-green';
        break;
      case 6:
        baseClass += ' pill pill-green';
        break;
      case 7:
        baseClass += ' pill pill-green';
        break;
      case 8:
        baseClass += ' pill pill-fuchsia';
        break;
      case 9:
        baseClass += ' pill pill-gray';
        break;
      case 10:
        baseClass += ' pill pill-rose';
        break;
      case 11:
        baseClass += ' pill pill-amber';
        break;
      case 12:
        baseClass += ' pill pill-emerald';
        break;
      case 13:
        baseClass += ' pill pill-red';
        break;
      default:
        baseClass += ' pill pill-dark';
        break;
    }
    return baseClass;
  }

  getStatusDot(status: number) {
    switch (status) {
      case 1:
        return 'fill-teal-500';
      case 2:
        return 'fill-blue-500';
      case 3:
        return 'fill-indigo-500';
      case 4:
        return 'fill-orange-500';
      case 5:
        return 'fill-green-500';
      case 6:
        return 'fill-green-500';
      case 7:
        return 'fill-green-500';
      case 8:
        return 'fill-fuchsia-500';
      case 9:
        return 'fill-gray-500';
      case 10:
        return 'fill-rose-500';
      case 11:
        return 'fill-amber-500';
      case 12:
        return 'fill-emerald-500';
      case 13:
        return 'fill-red-500';
      default:
        return 'fill-white';
    }
  }
}
